import { Button } from "@mui/material";
import PropTypes from "prop-types";

export const TableButton = (props) => {
  return (
    <Button
      sx={{
        "&:hover": {
          textDecoration: "underline",
        },
        fontSize: 14,
        fontWeight: 500,
      }}
      onClick={props.onClick}
    >
      {props.children}
    </Button>
  );
};

TableButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};
